import { HugeiconsIcon } from "@hugeicons/react";
import { Alert02Icon, Clock01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cva } from "class-variance-authority";
import type { FC } from "react";
import type { RewardNote as Note } from "../../types";

type Props = {
  note: Note;
};

const noteVariants = cva(
  "m-2 mt-0 flex items-center gap-2.5 rounded-xl p-3 text-foreground text-xs [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      kind: {
        cooldown: "bg-foreground/5 [&_svg]:text-muted-foreground",
        expiring: "bg-destructive/10 [&_svg]:text-destructive",
      },
    },
  },
);

const RewardNote: FC<Props> = ({ note }) => (
  <div data-slot="reward-note" className={noteVariants({ kind: note.kind })}>
    <HugeiconsIcon
      icon={note.kind === "expiring" ? Alert02Icon : Clock01Icon}
    />
    {note.text}
  </div>
);

export default RewardNote;
